<template>
  <div id="operationVideo">
    <div class="header" style="height: 100vh;padding-bottom: 46px;box-sizing: border-box;">
      <!-- `https://players.brightcove.net/3871979173001/experience_${galleryId}/index.html?bcemail=${$route.query.openid}&bctrackingid=${$route.query.openid}&bccustomguid=${$route.query.openid}` -->
      <iframe
        style="width:100%;height: 100%;"
        allowfullscreen="true"
        webkitallowfullscreen="true"
        mozallowfullscreen="true"
        id="brightCoveVideo"
        name="mainIframe"
        :src="`https://players.brightcove.net/3871979173001/uV8Govd5h_default/index.html?videoId=6233160382001&bcemail=${openId}&bctrackingid=${openId}&bccustomguid=${openId}`"
        frameborder="0"
        scrolling="auto">
      </iframe>
    </div>
    <agreeBookDialog :ABDialogShow="ABDialogShow" :openId="openId" @ABDialogShowFn="ABDialogShowFn"></agreeBookDialog>
  </div>
</template>

<script>
import agreeBookDialog from "../login/agreeBookDialog";
import merge from 'webpack-merge';
export default {
  name: 'myOperationVideo',
  data () {
    return {
      showPage: false,
      ABDialogShow:false,
      baseUrl: process.env.config.baseUrl,
      openId: '',
      returnurl: decodeURIComponent(this.$route.query.returnurl || ''),
      oriUrl: this.$route.query.returnurl || '',
      takedacode: this.$route.query.takedacode || '',
      jumptovctag: this.$route.query.jumptovctag || '',
      NewerTag: this.$route.query.NewerTag || '',
      galleryId: '602dcd48dad74c0022e52d40'
    }
  },
  components: { agreeBookDialog },
  created () {

//判断会传参数中是否有 jumptovctag ，如有则证明已经跳过了，如无，则无论如何都跳转
if(!this.jumptovctag){
  this.iframeUrl = process.env.config.baseUrl + '/api/wechat/oauth2/authorize?redirect_uri=' + encodeURIComponent('https://' + window.location.host + '/myOperationVideo?returnurl=' + encodeURIComponent((this.oriUrl || '')))
      window.location.href = this.iframeUrl
 }

     //如果参数中含有新用户标记，则清理缓存 (当前未考虑员工，仅考虑了医生)
     if(this.NewerTag=='Hcp'){
      window.sessionStorage.removeItem("LsData");
                // 注册成功删除暂存的用户信息
      window.localStorage.removeItem("registerUserInfo");
      window.localStorage.removeItem("registerNonHCPInfo");
                // 删除员工标识
      window.localStorage.removeItem("isEmployee");
    }
    else if(this.NewerTag=='Emp')
    {
      window.localStorage.setItem('isEmployee', true);

    }
    else if(this.NewerTag=='NoHcp')
    {
      window.localStorage.removeItem("registerNonHCPInfo");
      window.localStorage.removeItem("registerUserInfo");
    }


    if (!localStorage.TaToken && !this.takedacode) {
      this.iframeUrl = process.env.config.baseUrl + '/api/wechat/oauth2/authorize?redirect_uri=' + encodeURIComponent('https://' + window.location.host + '/myOperationVideo?returnurl=' + encodeURIComponent((this.oriUrl || '')))
      window.location.href = this.iframeUrl
    } else {
      if (this.takedacode && !localStorage.TaToken) {
        this.$axiox.get('/Login/GetTokenByCode?code=' + this.takedacode).then(msg => {
          localStorage.TaToken = msg.token
          localStorage.appId = msg.appId
          localStorage.openId = msg.openId
          this.openId = msg.openId
          this.showPage = true
        })
      } else {
        this.openId = localStorage.openId
        this.showPage = true
      }
    }

setTimeout(() => {
        this.getSignDetail();
        this.$router.push({
query:merge(this.$route.query,{'jumptovctag':''})
})
      }, 1500);

  },
  methods: {
getSignDetail() {
      let data = {
        openid: this.openId,
        docCode: "",
      };
      this.$axiox.postNoRes("/api/hcp/getHcpSignDetail", data).then((p) => {
        if (p.data == "True") {
          //name: "agreeBook",
            this.ABDialogShow = true;
        } else if (p.data == "False") {
        } //无需重新签署
        else {
        } //返回值错误
      });
    },
    ABDialogShowFn() {
      this.ABDialogShow =false;
    }
  }
}
</script>

<style scoped>
  #operationVideo {
    width: 100%;
  }
  .header {
    width: 100%;
    /* min-height: 300px; */
    /* border-bottom-left-radius: 45px; */
    /* border-bottom-right-radius: 45px; */
    /* box-shadow: 0px 13px 0px rgba(125, 17, 129, 0.74); */
    overflow: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/myPkFit/operationVideo.vue